__turbopack_context__.v({
  "card": "U79tCq_card",
});
